import PriorityBadge from "./PriorityBadge";
import ResponseBadge from "./ResponseBadge";
import WindowGauge from "./WindowGauge";
import AuditableFigure from "../common/AuditableFigure";
import { OUTCOME_LABELS } from "../../lib/copy";

/**
 * Row in an opportunities table. Money-first: first column is the estimated value.
 * Presentational only — click handlers passed in.
 */
export default function OpportunityRow({ opp, selected, onClick, testid }) {
  return (
    <tr
      data-testid={testid}
      onClick={onClick}
      className={`row-hover cursor-pointer border-b border-[#101728] ${
        selected
          ? "bg-amber-500/5 border-l-2 border-l-amber-500"
          : "border-l-2 border-l-transparent"
      }`}
    >
      <td className="px-6 py-3">
        <AuditableFigure estimate={opp.estimatedValue} compact />
      </td>
      <td className="px-4 py-3">
        <WindowGauge days={opp.windowDays} engineId={opp.engineId} />
      </td>
      <td className="px-4 py-3 max-w-[220px]">
        {/* Defecto real encontrado en pruebas destructivas: un nombre de
            empresa extremadamente largo (pegado por error, o adversario)
            rompía el layout de la tabla sin límite — sin max-w ni truncate
            no hay nada que lo contenga. */}
        <div className="text-sm text-zinc-100 font-medium truncate" title={opp.companyName}>{opp.companyName}</div>
        <div className="text-[10px] text-zinc-500 mt-0.5 truncate">{opp.contactName}</div>
      </td>
      <td className="px-4 py-3">
        <PriorityBadge priority={opp.priority} />
      </td>
      <td className="px-4 py-3">
        <ResponseBadge status={opp.responseStatus} />
      </td>
      <td className="px-4 py-3 text-zinc-400 text-[11px]">{opp.lastSignalLabel}</td>
      <td className="px-6 py-3">
        <span
          className={`text-[10px] font-mono uppercase tracking-[0.1em] ${
            opp.outcome === "won"
              ? "text-emerald-400"
              : opp.outcome === "lost"
                ? "text-red-400"
                : opp.outcome === "in_progress"
                  ? "text-amber-400"
                  : "text-zinc-500"
          }`}
        >
          {opp.outcome === "pending" ? "—" : OUTCOME_LABELS[opp.outcome] || opp.outcome}
        </span>
      </td>
    </tr>
  );
}
